<template>
  <v-chart
    class="v-chart"
    :options="options"
    :init-options="{}"
    autoresize
    @click="handleClick" />
</template>

<script>
import ECharts from '@/components/public/ECharts.vue'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
export default {
  name: 'SafeSkuChart',
  components: {
    'v-chart': ECharts
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    xAxis: {
      type: Array,
      default() {
        return []
      }
    },
    series1: {
      type: Array,
      default() {
        return []
      }
    },
    series2: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
    }
  },
  computed: {
    options() {
      return {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['低于安全库存仓库数', '高于安全库存仓库数']
        },
        xAxis: [
          {
            type: 'category',
            data: this.xAxis,
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              rotate: 45
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            min: 0,
            axisLabel: {
              formatter: '{value}个'
            }
          }
        ],
        series: [
          {
            name: '低于安全库存仓库数',
            type: 'bar',
            stack: '仓库数',
            data: this.series1.map((i, idx) => {
              return {
                name: '低于安全库存仓库数',
                value: i,
                itemStyle: {
                  color: this.index === idx ? '#C25552' : 'rgba(194, 85, 82,0.6)'
                }
              }
            })
          },
          {
            name: '高于安全库存仓库数',
            type: 'bar',
            stack: '仓库数',
            data: this.series2.map((i, idx) => {
              return {
                name: '高于安全库存仓库数',
                value: i,
                itemStyle: {
                  color: this.index === idx ? '#51616D' : 'rgba(81, 97, 109,0.6)'

                }
              }
            })
          }
        ]
      }
    }
  },
  methods: {
    handleClick(params) {
      this.$emit('setIndex', params.dataIndex)
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-chart {
    height 250px!important
}
</style>
